import Recall from "../../pages/snail/sixthAnniveRecall/index.vue";

const base = "sixthAnniveRecall";

const routes = [
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Recall
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/sixthAnniveRecall.js